export default __webpack_public_path__ + "static/media/discounts-bogo-image.3556dd1c.svg";